'use client'
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, Link as RouterLink } from "react-router-dom";
import { RootState } from "types";

import { Container, Box } from "@mui/material";
import SignIn from "./sections/SignIn";

function SignInPage() {
  const navigate = useNavigate();
  const user = useSelector((state: RootState) => state.user.user);

  useEffect(() => {
    if (user) navigate("/home", { replace: true });
  }, [user, navigate]);

  const setSignup = () => navigate("/signup");
  const setPassReset = () => navigate("/reset-password");

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        my: 8,
      }}
    >
      <Container component="main" maxWidth="xs">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
          }}
        >
          <SignIn setSignup={setSignup} setPassReset={setPassReset} />
        </Box>
      </Container>
    </Box>
  );
}

export default SignInPage;